import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { loginWithMicrosoft } from '@/lib/auth';
import { AlertCircleIcon } from 'lucide-react';

function MicrosoftLogo() {
  return (
    <svg className="h-4 w-4" viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

export function Login() {
  const [error, setError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  const onSignIn = async () => {
    setError(null);
    setPending(true);
    try {
      // On success onAuthStateChanged in App.tsx picks up the user and
      // UnsecureRoute redirects to the dashboard.
      await loginWithMicrosoft();
    } catch (e) {
      const err = e as { code?: string; message?: string };
      // Closing the popup isn't an error worth surfacing.
      if (
        err.code !== 'auth/popup-closed-by-user' &&
        err.code !== 'auth/cancelled-popup-request'
      ) {
        setError(
          err.code === 'auth/popup-blocked'
            ? 'The sign-in popup was blocked. Allow popups for this site and try again.'
            : 'Sign-in failed. Make sure you use your organization account, or contact an administrator.'
        );
      }
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="mx-auto grid w-[350px] gap-6">
      <div className="grid gap-2 text-center">
        <h1 className="text-3xl font-bold">Log in to your account</h1>
        <p className="text-balance text-muted-foreground">
          Sign in with your organization&apos;s Microsoft account
        </p>
      </div>
      <div className="grid gap-4">
        <Button
          type="button"
          className="w-full gap-2"
          onClick={onSignIn}
          disabled={pending}
        >
          <MicrosoftLogo />
          {pending ? 'Waiting for Microsoft…' : 'Sign in with Microsoft'}
        </Button>
        {error && (
          <p className="flex items-center gap-2 text-xs text-destructive">
            <AlertCircleIcon className="h-4 w-4 shrink-0" />
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
